import {
  CREATE_ACTIVITY_STORY,
  POST_STORY_COMMENT,
  POST_STORY_IMAGE,
  GET_ACTIVITY_FEED,
  LIKE_STORY,
  UNLIKE_STORY,
  POST_COMMENT,
  DELETE_COMMENT,
  DELETE_STORY,
  GET_STORY_COMMENTS,
} from './constants'

import * as user from 'services/user/selectors'
import * as helpers from './helpers'

export function postStoryComment (userId, text, privacySetting, file) {
  const body = helpers.constructStoryBody(userId, text, privacySetting, file)

  return (dispatch, getState, { mapmy }) => {
    return dispatch({
      type: POST_STORY_COMMENT,
      payload: mapmy.createActivityStoryComment(body),
    })
  }
}

export function postStoryImage (storyLink, file) {
  const formData = new FormData()
  const metaData = JSON.stringify({
    rel: 'attachments',
    index: 0,
    href: storyLink,
  })
  const blob = new Blob([metaData], { type: 'text/json' })

  formData.append('image', file)
  formData.append('data', blob, 'data.json')

  return (dispatch, getState, { mapmy }) => {
    return dispatch({
      type: POST_STORY_IMAGE,
      payload: mapmy.postImage(formData),
    })
  }
}

export function createActivityStory (userId, text, privacySetting, file = null) {
  return (dispatch) => {
    const promise = Promise.resolve()
      .then(() => {
        return dispatch(postStoryComment(userId, text, privacySetting, file))
      })
      .then((story) => {
        const storyLink = story.value.data._links.self[0].href

        if (file) {
          return dispatch(postStoryImage(storyLink, file)).then(() => {
            return Promise.resolve(story)
          })
        }

        return Promise.resolve().then(() => {
          return Promise.resolve(story)
        })
      })
    return dispatch({
      type: CREATE_ACTIVITY_STORY,
      payload: promise,
    })
  }
}

export function getActivityFeed (userId, feedType, limit = 20) {
  return (dispatch, getState, { mapmy }) => {
    return dispatch({
      type: GET_ACTIVITY_FEED,
      payload: mapmy.getActivityFeed(userId, feedType, limit),
    })
  }
}

export function likeStory (userId, storyId) {
  return (dispatch, getState, { mapmy }) => {
    const name = user.selectDisplayName(getState())
    return dispatch({
      type: LIKE_STORY,
      payload: mapmy.likeStory(userId, storyId, name),
      meta: {
        storyId: storyId,
        userId: userId,
      },
    })
  }
}

export function unlikeStory (userId, story) {
  return (dispatch, getState, { mapmy }) => {
    return dispatch({
      type: UNLIKE_STORY,
      payload: mapmy.unlikeStory(story.likes.reply_id),
      meta: {
        userId: userId,
        storyId: story.id,
      },
    })
  }
}

export function postComment (text, storyId) {
  return (dispatch, getState, { mapmy }) => {
    const actor = {
      title: user.selectDisplayName(getState()),
      id: user.selectUserId(getState()),
      type: 'user',
      gender: user.selectGender(getState()),
    }

    return dispatch({
      type: POST_COMMENT,
      payload: mapmy.postStoryComment(text, actor, storyId),
      meta: {
        storyId: storyId,
      },
    })
  }
}

export function deleteComment (commentId, storyId) {
  return (dispatch, getState, { mapmy }) => {
    return dispatch({
      type: DELETE_COMMENT,
      payload: mapmy.deleteComment(commentId),
      meta: {
        commentId: commentId,
        storyId: storyId,
      },
    })
  }
}

export function deleteStory (storyId) {
  return (dispatch, getState, { mapmy }) => {
    return dispatch({
      type: DELETE_STORY,
      payload: mapmy.deleteStory(storyId),
      meta: {
        storyId: storyId,
      },
    })
  }
}

export function getStoryComments (storyId) {
  return (dispatch, getState, { mapmy }) => {
    return dispatch({
      type: GET_STORY_COMMENTS,
      payload: mapmy.getStoryComments(storyId),
      meta: {
        storyId: storyId,
      },
    })
  }
}
